export function formatMinutes(value: number): string {
    if (value !== null && value !== undefined) {
        const hours = Math.floor(value / 60);
        const minutes = value % 60;
        return hours + ":" + ((minutes < 10) ? ("0" + minutes) : minutes.toString());
    } else {
        return '';
    }
}
